import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { NgxUiLoaderModule, NgxUiLoaderHttpModule, SPINNER, NgxUiLoaderConfig, POSITION, PB_DIRECTION, NgxUiLoaderRouterModule } from 'ngx-ui-loader'
import { DatePipe } from '@angular/common';
import { CookieLawModule } from 'angular2-cookie-law';
import { HttpClientModule } from '@angular/common/http';
import { Ng5SliderModule } from 'ng5-slider';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  blur: 0.5,
  bgsColor: '#OOACC1',
  bgsOpacity: 0.5,
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 100,
  bgsType: SPINNER.chasingDots,
  fgsColor: '#283583',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 80,
  fgsType: SPINNER.ballSpinClockwise,
  // logoUrl: 'assets/images/ikycLogo.png',
  pbColor: '#283583',
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 2,
  text: '',
  textColor: '#283583',
  textPosition: POSITION.centerCenter,
  overlayColor: 'rgba(40, 40, 40, 0.2)'
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule
    , BrowserAnimationsModule
    , AppRoutingModule
    , SharedModule
    , CoreModule
    , NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)
    , NgxUiLoaderHttpModule.forRoot({ showForeground: true, exclude: [`https://api.ikyc.eu/api/healthcheck/healthcheckindicator`] }) // Added by PPA for testing. Will be removed in later releases.
    , CookieLawModule // import Angular's CookieLaw modules 
    , HttpClientModule
    , Ng5SliderModule
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
